import { FC } from 'react';
import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import { useProductStore } from '@elem/compPage/CES2025/ProductProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const C: FC = () => {
    const { t } = useLang('ces2025');
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    const { pageStatus } = useProductStore();

    const props = {
        contactListId: ['1487185288'],
        isMulti: true,
        source: 'WEB_CAMPAIGN_SUB',
        theme: 'black',
        text: pageStatus === 'statusA' ? t('C_text') : t('C_text2'),
        fields: [
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '4423',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '12135',
                type: 'text',
                value: dateString,
                overwrite: false,
            },
        ],
        productList: [
            {
                value: '1',
                label: t('C_role1'),
                checked: false,
                fields: [
                    {
                        id: '12134',
                        type: 'multiple',
                        value: [1],
                        overwrite: true,
                    },
                ],
            },
            {
                value: '2',
                label: t('C_role2'),
                checked: true,
                fields: [
                    {
                        id: '12134',
                        type: 'multiple',
                        value: [2],
                        overwrite: false,
                    },
                ],
            },
        ],
        tipsObj: {
            btnText: t('C_btn'),
            placeholder: t('C_placeholder'),
            tipsEmpty: t('C_tip_empty'),
            tipsTypeError: t('C_tip_error'),
            successTips: t('C_tip_success'),
            tipsCheck: t('C_tip_check'),
            tipsProductEmpty: t('C_tip_role'),
        },
        needTerms: true,
        termsHtml:
            "I agree to the <a href='https://account.ecoflow.com/agreement/en-us/TermsOfUse.html' target='_blank'>Terms of Service</a> and <a href='https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html' target='_blank'>Privacy Policy</a>.",
    };

    return (
        <section className={styles.section} id="CES-2025-C">
            <EfSpec />
            <div className="box">
                <div className="left">
                    <p className="sec-title">{pageStatus === 'statusA' ? t('C_title') : t('C_title2')}</p>
                    <p className="desc">{pageStatus === 'statusA' ? t('C_desc') : t('C_desc2')}</p>
                    <EfEmarsysEmail {...props} />
                </div>
                <div className="right">
                    <EfImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1733205730551/C_PC.jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1733205730551/C_PC.jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1733205740085/C_M.jpg"
                    />
                </div>
            </div>
        </section>
    );
};

export default C;
